import React, {Component} from 'react';
import * as PropTypes from 'prop-types';
import {ButtonStyles, IconStyles} from "./styles/IconButton.css";

class IconButton extends Component {
    constructor(props){
        super(props);

        this.state = {
          hovered: false,
          classNames: "",
          buttonStyles: {},
          disabled: false,
          additionalStyles: {}
        };
    }

    componentDidMount() {
      let disabled = this.props.disabled || false;
      let classNames = this.getClassNames();
      let buttonStyles = this.getUpdatedButtonStyles(disabled);
      this.setState({classNames, buttonStyles, disabled});
    }

  componentWillReceiveProps(nextProps) {
    if(nextProps.classNames !== this.state.classNames) {
      this.setState({classNames: nextProps.classNames});
    }
    if(nextProps.additionalStyles !== this.state.additionalStyles) {
      this.setState({additionalStyles: nextProps.additionalStyles});
    }
    if(nextProps.disabled !== this.state.disabled) {
      this.setState({disabled: nextProps.disabled});
    }

  }

    componentDidUpdate(prevProps, prevState) {
      let classNames;
      let buttonStyles;

      if(prevState.hovered !== this.state.hovered) {
       let buttonStyles = this.getUpdatedButtonStyles();
        this.setState({buttonStyles});
      }

      if(prevState.classNames !== this.state.classNames) {
        classNames = this.getClassNames();
      }
      if(prevState.additionalStyles !== this.state.additionalStyles) {
        buttonStyles = this.getUpdatedButtonStyles();
      }
      if(prevState.disabled !== this.state.disabled) {
        buttonStyles = this.getUpdatedButtonStyles();
      }

      if(!buttonStyles && !classNames)
        return;

      if(classNames && buttonStyles)
        this.setState({buttonStyles, classNames});
      else if(classNames)
        this.setState({classNames});
      else
        this.setState({buttonStyles});
    }


    getUpdatedButtonStyles = () => {
      let buttonStyles = {};
      let disabled = this.state.disabled;
      let styles = ButtonStyles({hovered: this.state.hovered && !disabled, disabled});
      if(this.props.additionalStyles) {
        Object.assign(buttonStyles, styles, this.props.additionalStyles);
      }
      else buttonStyles = styles;

      return buttonStyles;
    };

    getClassNames = () => {
      let classNames = "btn btn-sm";
      if(this.props.classNames != null && Array.isArray(this.props.classNames)) {
        this.props.classNames.forEach((className) => {
          classNames += " " + className.toString();
        });
      }
      return classNames;
    };

  toggleHover = (hovered) => {
    this.setState({hovered});
  };

    render(){
      let iconType = this.props.iconType;
      if(this.props.disabled) {
        return (
          <button className={this.state.classNames} style={this.state.buttonStyles} disabled={true}>
            <i className="material-icons" style={IconStyles}>{iconType}</i>
          </button>
        )
      }
      else
        return(
        <button className={this.state.classNames} style={this.state.buttonStyles} onMouseEnter={() => this.toggleHover(true)}
                onMouseLeave={() => this.toggleHover(false)} onClick={this.props.action}>
          <i className="material-icons" style={IconStyles}>{iconType}</i>
        </button>
        );
    }
}

IconButton.propTypes = {
  //Material icon name
  iconType: PropTypes.string.isRequired,
  //Array of strings representing css classes
  classNames: PropTypes.array,
  //Object representing additional styles
  //Will be merged with existing styles
  additionalStyles: PropTypes.object,
  //What should happen when button is pressed
  action: PropTypes.func,
  //If the button should be active
  disabled: PropTypes.bool
};

export default IconButton;
